
import React, { useState } from "react";
import api from "./api";

const validatePassword = (password) => {
  return (
    password.length >= 12 &&
    /[A-Z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  );
};

const ResetPassword = ({ onBack }) => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const token = new URLSearchParams(window.location.search)
        .get("token") || "";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        if (!token) {
            setError("Link nie zawiera tokenu. Poproś o nowy link.");
            return;
        }

       if (!validatePassword(password)) {
        setError(
            "Hasło musi mieć minimum 12 znaków, jedną dużą literę, jedną cyfrę i jeden znak specjalny."
        );
        return;
        }

        if (password !== confirmPassword) {
            setError("Podane hasła nie są identyczne.");
            return;
        }

        setLoading(true);

        try {
            const res = await api.post("/reset-password.php", {
                token,
                password
            });

            setMessage(
                res.data.message ||
                "Hasło zostało zmienione. Możesz się zalogować."
            );
            setPassword("");
            setConfirmPassword("");
        } catch (err) {
            setError(
                err.response?.data?.error ||
                "Nie udało się zmienić hasła. Poproś o nowy link."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-box">
                <h2>ROD ZGODA Bytom</h2>
                <h2>Ustaw nowe hasło</h2>
                <p className="subtitle">
                    Wpisz nowe hasło do swojego konta.
                </p>

                {!token ? (
                    <p className="message" role="alert">
                        Brak tokenu w linku. Poproś o nowy link resetujący.
                    </p>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <input
                            type="password"
                            placeholder="Nowe hasło (min. 12 znaków)"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="new-password"
                            minLength={12}
                            maxLength={4096}
                            required
                        />

                        <input
                            type="password"
                            placeholder="Powtórz nowe hasło"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            autoComplete="new-password"
                            minLength={12}
                            maxLength={4096}
                            required
                        />

                        <button type="submit" disabled={loading}>
                            {loading ? "Zapisywanie..." : "Zmień hasło"}
                        </button>
                    </form>
                )}

                {message && (
                    <p className="message" role="status">{message}</p>
                )}

                {error && (
                    <p className="message" role="alert">{error}</p>
                )}

                <button onClick={() => {
                window.location.href = "/";
                }}>
                Wróć do logowania
                </button>
            </div>
        </div>
    );
};

export default ResetPassword;
